import React from 'react';
import { Navigate } from 'react-router-dom';

const ShopifyAdminIndex: React.FC = () => {
  return <Navigate to="/shopify-admin/profile" replace />;
};

export default ShopifyAdminIndex;
